<div mat-dialog-content class="message-card" [class]="typeMessageClass"><i class="fa-regular fa-circle-info"></i>
  {{ message }}
</div>
